import { createSlice } from "@reduxjs/toolkit";
import { PaginationResponse, ResponseData } from "api/types/_public";
import { IAdvertiserAgencyReport } from "api/types/_advertiser";
import { advertiserAgencyReport } from "./thunk";

export interface IState {
  advertiserAgencies: ResponseData<IAdvertiserAgencyReport[]> & PaginationResponse | null,
  isAdvertiserAgencyReportLoading: boolean,
  isAdvertiserAgencyReportSuccess: boolean,

  error: any,
};

export const initialState: IState = {
  advertiserAgencies: null,
  isAdvertiserAgencyReportLoading: false,
  isAdvertiserAgencyReportSuccess: false,

  error: {},
};

const ReportSlice = createSlice({
  name: "Report",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    //report
    builder.addCase(advertiserAgencyReport.pending, (state: IState, action: any) => {
      state.isAdvertiserAgencyReportLoading = true
    });
    builder.addCase(advertiserAgencyReport.fulfilled, (state: IState, action: any) => {
      state.advertiserAgencies = action.payload.data;
      state.isAdvertiserAgencyReportSuccess = true;
      state.isAdvertiserAgencyReportLoading = false;
    });
    builder.addCase(advertiserAgencyReport.rejected, (state: IState, action: any) => {
      state.error = action.payload.error || null;
      state.isAdvertiserAgencyReportSuccess = false;
      state.isAdvertiserAgencyReportLoading = false;
    });
  },
});

export default ReportSlice.reducer;